export enum AuthGroupType {
  Role = "ROLE",
  Group = "GROUP",
}

export interface AuthGroup {
  code: string;
  domain: string;
  description?: string;
  scopes: string[];
  title: string;
  type: AuthGroupType;
}

export enum ApplicationScopes {
  CompanyAdmin = "akorda:all",
  ReviewCreate = "ui-review:create",
  ReviewRead = "ui-review:read",
  ReviewListAll = "ui-review:list",
  ReviewListMyDocuments = "ui-review:list:own",
  ReviewEditContent = "ui-review:edit-content",
  ReviewWrite = "ui-review:write",
  ReviewAssemble = "ui-review:assemble",
  ReviewSend = "ui-review:send",
  ReviewDownload = "ui-review:download",
  ReviewManageAccess = "ui-review:manage-access",
  ReviewAssign = "ui-review:assign",
  ReviewAssignOwn = "ui-review:assign:own",
  ReviewFinalize = "ui-review:finalize",
  ReviewDelete = "ui-review:delete",
  ReviewViewHistory = "ui-review:view-history",
  TicketListAll = "ui-ticket:list",
  TicketListMyTickets = "ui-ticket:list:own",
  TicketCreate = "ui-ticket:create",
  TicketDelete = "ui-ticket:delete",
  TicketRead = "ui-ticket:read",
  TicketWrite = "ui-ticket:write",
  TicketAssign = "ui-ticket:assign",
  TicketAssignOwn = "ui-ticket:assign:own",
  TicketChangePriority = "ui-ticket:change-priority",
  TicketChangeStatus = "ui-ticket:change-status",
  TicketAddOthersAsFollowers = "ui-ticket:add-others-as-followers",
  DocumentCreate = "ui-document:create",
  DocumentList = "ui-document:list",
  DocumentRead = "ui-document:read",
  DocumentWrite = "ui-document:write",
  DocumentDelete = "ui-document:delete",
  DocumentDownload = "ui-document:download",
  DocumentEditLockedFields = "ui-document:edit-locked-fields",
  DocumentListExport = "ui-document:export-results",
  DocumentManageAccess = "ui-document:manage-access",
  DocumentViewHistory = "ui-document:view-history",
  DocumentManageRenewalReminders = "ui-document:manage-renewal-reminders",
  PlaybookCreate = "ui-playbook:create",
  PlaybookList = "ui-playbook:list",
  PlaybookLibrary = "ui-playbook:library",
  PlaybookWrite = "ui-playbook:write",
  PlaybookDelete = "ui-playbook:delete",
  PlaybookView = "ui-playbook:view",
  PlaybookAssemblyConfigure = "ui-playbook:assembly",
  PlaybookInsightsRead = "ui-playbook:insights-read",
  PlaybookInsightsExport = "ui-playbook:insights:export",
  InsightsGenerateProposals = "ui-playbook:insights:generate-fallback-proposals",
  CounterpartyDelete = "ui-counterparty:delete",
  CounterpartyWrite = "ui-counterparty:write",
  CounterpartyFolders = "ui-counterparty:folder",
  AdministrationFields = "ui-administration:fields",
  AdministrationCustomFields = "ui-administration:custom-fields",
  AdministrationOrderTables = "ui-administration:order-tables",
  AdministrationTicketTypes = "ui-administration:ticket-types",
}

export enum DocumentPermission {
  Action = "document:action",
  Create = "document:create",
  Delete = "document:delete",
  EditLockedFields = "document:edit-locked-fields",
  ManageAccess = "document:access",
  Read = "document:read",
  Review = "document:review",
  Write = "document:write",
}

export function getScopes(authGroup: AuthGroup): string[] {
  const { scopes = [] } = authGroup ?? {};
  return scopes;
}

export function getAuthGroupType(authGroup: AuthGroup) {
  return authGroup?.type;
}

export function isRole(authGroup: AuthGroup) {
  return getAuthGroupType(authGroup) === AuthGroupType.Role;
}

export function isGroup(authGroup: AuthGroup) {
  return getAuthGroupType(authGroup) === AuthGroupType.Group;
}
